import React, { useEffect } from 'react';
import { OverlayScrollArea } from '@odo/shared-ui';
import { usePageTitle } from '../hooks/usePageTitle';
import { usePageHeader } from '../providers/PageHeaderProvider';
import { useUser } from '../providers/UserProvider';
import { MY_LIST_LIMIT, useMyAssignedCases, useMyUnreadConversations } from '../hooks/useHomeStats';
import { HomeSummaryRow } from '../components/home/HomeSummaryRow';
import { TeamWorkloadSection } from '../components/home/TeamWorkloadSection';

// The admin landing page: my to-do lists on top, every team's workload below.

const Home: React.FC = () => {
    usePageTitle('Home');
    const { setTitle, setSubtitle } = usePageHeader();
    const { user } = useUser();

    useEffect(() => {
        setTitle(user?.name ? `Welcome back, ${user.name}` : 'Home');
        setSubtitle(null);
        return () => {
            setTitle(null);
            setSubtitle(null);
        };
    }, [user?.name, setTitle, setSubtitle]);

    const {
        myCases,
        isLoading: myCasesLoading,
        isError: myCasesError
    } = useMyAssignedCases(MY_LIST_LIMIT);
    const {
        conversations: myConversations,
        isLoading: myConversationsLoading,
        isError: myConversationsError
    } = useMyUnreadConversations(MY_LIST_LIMIT);

    return (
        <OverlayScrollArea className="h-full bg-gray-100" contentClassName="px-4 sm:px-8 pt-2 pb-6">
            <div className="flex flex-col gap-6">
                <section className="flex flex-col gap-3">
                    <h2 className="text-lg font-bold text-gray-900">To-do</h2>
                    <HomeSummaryRow
                        cases={myCases?.cases ?? []}
                        casesTotal={myCases?.total ?? 0}
                        casesLoading={myCasesLoading}
                        casesError={myCasesError}
                        conversations={myConversations}
                        conversationsLoading={myConversationsLoading}
                        conversationsError={myConversationsError}
                        className="md:h-[280px]"
                    />
                </section>

                <TeamWorkloadSection />
            </div>
        </OverlayScrollArea>
    );
};

export { Home };
